module.exports = __webpack_public_path__ + "static/media/luana.a1448bb6.jpeg";